import React, { useEffect, useState } from "react";
import { validateLeadershipTable } from "../../../../utils/validateTable";
import { restructureData } from "../../../../utils/restructureData";
import { get, put } from "../../../../utils/api";
import { Box, Button } from "@mui/material";
import DynamicTable from "../../../Common/DynamicTable";
import InputField from "../../../Masters/InputField";
import RadioButtons from "../../../Common/RadioButtons";
import EastIcon from "@mui/icons-material/East";
import MessagePopup from "../../../Masters/MessagePopup";
import style from "../../../../styles/brsr/general.module.css";
import { useNavigate, useParams } from "react-router-dom";
import { brsrReview, reviewBRSR } from "../../../../utils/companyId";
import ReviewBox from "../../../Common/ReviewBox";
import { currentYear } from "../../../../utils/generateYearRanges";
import BRSRFile from "../../../Common/BRSRFile";

const LeadershipIndicator = ({ onSave, hide, removeUpload = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [modalupload, setModalUpload] = useState({
    awarenessProgramDoc: false,
    avoidManageConflictDoc: false,
  });
  const percentageData = [
    {
      fieldName: "awarenessProgram",
      title:
        "1. Awareness programmes conducted for value chain partners on any of the Principles during the financial year:",
      type: "array",
      fields: [
        {
          fieldName: "totalProgram",
          title: "Total No. of Awareness Programs held",
          placeholder: "Enter Number",
          width: "10rem",
          type: "number",
        },
        {
          fieldName: "topicsPrinciples",
          title: "Topics / principles covered under the training",
          placeholder: "Select",
          type: "select",
          multiselect: true,
          options: [
            "Select All",
            "P1",
            "P2",
            "P3",
            "P4",
            "P5",
            "P6",
            "P7",
            "P8",
            "P9",
          ],
          width: "15rem",
        },
        {
          fieldName: "percentage",
          title:
            "%age of value chain partners covered (by value of business done with such partners) under the awareness programmes",
          placeholder: "Enter Percentage",
          type: "percentage",
          width: "20rem",
        },
      ],
    },
  ];

  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [tabErrors, setTabErrors] = useState({});
  const [tables, setTables] = useState([]);
  const [errors, setErrors] = useState({});

  const [data, setData] = useState({});

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await get(
        `/brsr/get?subType=principle1&type=SectionC&id=${id}`,
      );
      const res1 =
        res?.data?.data?.BRSRSectionC?.principle1?.leadershipIndicator;
      if (
        res?.data?.data?.year
          ? res?.data?.data?.year < currentYear - 1
          : false || !brsrReview
      )
        setDisabled(true);

      setData(res1);
    } catch (err) {
      console.log(err);
    }
  };

  const [formData, setFormData] = useState({});

  useEffect(() => {
    if (data) {
      setFormData({
        avoidManageConflictDoc: data?.avoidManageConflictDoc,
        awarenessProgramDoc: data?.awarenessProgramDoc,
        avoidManageConflict: data?.avoidManageConflict || {
          status: true, // Default boolean value
          remark: "", // Default empty string
        },
      });
    }
  }, [data]);

  const handleSubmit = async () => {
    if (!disabled) {
      let isValid = true;
      if (
        formData?.avoidManageConflict?.status === true &&
        formData?.avoidManageConflict?.remark === ""
      ) {
        isValid = false;
        setErrors({ ...errors, remark: "This field is Required" });
      }
      if (!validateLeadershipTable(percentageData, tables, setTabErrors))
        isValid = false;

      if (!isValid) return;

      let transformedData = restructureData(tables);

      transformedData = {
        leadershipIndicator: {
          ...formData,
          avoidManageConflict: {
            status: formData?.avoidManageConflict?.status,
            remark: formData?.avoidManageConflict?.status
              ? formData?.avoidManageConflict?.remark
              : "",
          },
          ...transformedData,
        },
        leadershipIndicatorSubmitted: true,
        type: "SectionC",
        subType: "principle1",
      };

      try {
        const res = await put(`/brsr/update?id=${id}`, transformedData);
        setsnackOpen({
          open: true,
          message: res.data.message,
          severity: "success",
        });
        navigate(`/brsr/section-c/principle2/${id}`);
      } catch (error) {
        setsnackOpen({
          open: true,
          message: error.data.message,
          severity: "error",
        });
      }
    } else navigate(`/brsr/section-c/principle2/${id}`);
  };

  return (
    <Box>
      <p className={style.subHeading}>II. LEADERSHIP INDICATOR</p>
      <MessagePopup {...{ snackOpen, setsnackOpen }} />{" "}
      <DynamicTable
        {...{
          inputData: percentageData,
          handleSubmit,
          tables,
          setTables,
          errors: tabErrors,
          setErrors: setTabErrors,
          data: data,
          disabled,
          hide,
        }}
      />
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "awarenessProgramDoc",
          ml: 2,
          removeUpload,
        }}
      />
      <RadioButtons
        title={
          "2. Does the entity have processes in place to avoid / manage conflict of interests involving members of the Board? If Yes, provide details of the same."
        }
        disabled={disabled}
        value={formData?.avoidManageConflict?.status || false}
        handleChange={(e) => {
          const value = e.target.value === "true"; // Convert string to boolean
          setFormData((prev) => ({
            ...prev,
            avoidManageConflict: {
              ...prev.avoidManageConflict,
              status: value,
            },
          }));
        }}
      />
      {formData?.avoidManageConflict?.status && (
        <Box sx={{ ml: 2 }}>
          <InputField
            disabled={disabled}
            placeholder={"Enter text"}
            errors={errors["remark"] && true}
            value={formData?.avoidManageConflict?.remark || ""}
            name="essentialIndicators.correctiveActions"
            handleChange={(e) => {
              setErrors({ ...errors, remark: "" });
              setFormData((prev) => ({
                ...prev,
                avoidManageConflict: {
                  ...prev.avoidManageConflict,
                  remark: e.target.value,
                },
              }));
            }}
          />
          <p
            color="error"
            variant="caption"
            style={{
              lineHeight: "1.2",
              margin: "2px 0",
              marginTop: "5px",
              color: "#d34040",
              fontSize: "10px",
              fontStyle: "italic",
            }}
          >
            {errors["remark"]}
          </p>
        </Box>
      )}
      <BRSRFile
        {...{
          modalupload,
          setModalUpload,
          formData,
          setFormData,
          errors,
          setErrors,
          Uploadkey: "avoidManageConflictDoc",
          ml: 2,
          removeUpload,
        }}
      />
      {!hide && (
        <>
          {brsrReview ? (
            <Box sx={{ ml: "1rem", width: "98%" }}>
              <ReviewBox
                url={`/brsr/review/${id}`}
                handleSubmit={handleSubmit}
              />
            </Box>
          ) : (
            <Box textAlign="right" sx={{ mt: 3 }}>
              <Button
                onClick={handleSubmit}
                variant="contained"
                sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              >
                Save & Continue <EastIcon sx={{ ml: 2 }} />
              </Button>
            </Box>
          )}
        </>
      )}
    </Box>
  );
};

export default LeadershipIndicator;
